import api from '../api'; // import your configured axios instance
import { API_URL } from '../config';

// GET all positions for a specific employee
export const getEmployeePositions = async (employeeId) => {
  try {
    const response = await api.get(`${API_URL}/employees/${employeeId}/positions`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching positions for employee ${employeeId}:`, error);
    throw new Error(error.response?.data?.message || 'Failed to fetch employee positions');
  }
};

// POST create a new position for an employee
export const createEmployeePosition = async (employeeId, positionData) => {
  try {
    const response = await api.post(`${API_URL}/employees/${employeeId}/positions`, positionData);
    return response.data;
  } catch (error) {
    console.error(`Error creating position for employee ${employeeId}:`, error);
    throw new Error(error.response?.data?.message || 'Failed to create position');
  }
};

// GET a specific position by ID for an employee
export const getEmployeePosition = async (employeeId, positionId) => {
  try {
    const response = await api.get(`${API_URL}/employees/${employeeId}/positions/${positionId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching position ${positionId} for employee ${employeeId}:`, error);
    throw new Error(error.response?.data?.message || 'Failed to fetch position');
  }
};

// PUT update a specific position for an employee
export const updateEmployeePosition = async (employeeId, positionId, positionData) => {
  try {
    const response = await api.put(`${API_URL}/employees/${employeeId}/positions/${positionId}`, positionData);
    return response.data;
  } catch (error) {
    console.error(`Error updating position ${positionId} for employee ${employeeId}:`, error);
    throw new Error(error.response?.data?.message || 'Failed to update position');
  }
};

// DELETE a specific position for an employee
export const deleteEmployeePosition = async (employeeId, positionId) => {
  try {
    const response = await api.delete(`${API_URL}/employees/${employeeId}/positions/${positionId}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting position ${positionId} for employee ${employeeId}:`, error);
    throw new Error(error.response?.data?.message || 'Failed to delete position');
  }
};

// Helper function to format positions array for display
export const formatPositionsDisplay = (employee) => {
  // Handle new positions array structure
  if (employee?.positions && Array.isArray(employee.positions)) {
    const validPositions = employee.positions.filter(pos => pos && pos.positionName);
    if (validPositions.length > 0) {
      return validPositions.map(pos => pos.positionName).join('; ');
    }
  }
  // Fallback to old single position attribute
  return employee?.position || 'N/A';
};

// Helper function to get positions with FTE details
export const formatPositionsWithFTE = (employee) => {
  if (employee?.positions && Array.isArray(employee.positions)) {
    const validPositions = employee.positions.filter(pos => pos && pos.positionName);
    if (validPositions.length > 0) {
      return validPositions.map(pos => `${pos.positionName} (${pos.fte || 1.0} FTE)`).join('; ');
    }
  }
  return employee?.position || 'N/A';
};
